import { getDictionary } from '@/shared/lib/i18n';
import { InterviewType } from '../../model';
import { InterviewValue } from './InterviewTypeSelection.types';

const createEmptyErrors = (): Partial<InterviewValue> => {
  return {};
};

export const validate = (interviewType: InterviewType | null, value: InterviewValue) => {
  const dictionary = getDictionary();
  const errors = createEmptyErrors();

  if (interviewType === InterviewType.InPerson) {
    if (!value.address) {
      errors.address = dictionary.thisFieldIsRequired;
    }

    if (!value.phone) {
      errors.phone = dictionary.thisFieldIsRequired;
    }
  }

  if (interviewType === InterviewType.Call) {
    if (!value.phone) {
      errors.phone = dictionary.thisFieldIsRequired;
    }
  }

  return Object.keys(errors).length > 0 ? errors : undefined;
};
